export const roleToString = role => {
  switch (role) {
    case 'guest':
      return 'Vieras';
    case 'user':
      return 'Käyttäjä';
    case 'inspector':
      return 'Tarkastaja';
    case 'department':
      return 'Osasto';
    case 'superuser':
      return 'Pääkäyttäjä';
    default:
      return 'Tuntematon';
  }
};

export const statusToString = (status) => {
	switch (status) {
		case 'completed':
			return 'Valmis';
		case 'pending':
			return 'Kesken';
		case 'waitingForPricing':
		case 'waitingForInspectorPricing':
			return 'Odottaa arviota';
		case 'new':
			return 'Uusi';
		case 'waitingForDepartmentPricing':
			return 'Odottaa osaston arviota';
		default:
			return '';
	}
};


export const uppercaseFirst = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};


// WEBPACK FOOTER //
// ./src/utils/user-utils.js